import "@/App.css";
import { Toaster } from "sonner";
import { BookingProvider } from "@/BookingContext";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Pillars from "@/components/Pillars";
import Coaching from "@/components/Coaching";
import CleanEnergy from "@/components/CleanEnergy";
import Pricing from "@/components/Pricing";
import Books from "@/components/Books";
import MeVsMe from "@/components/MeVsMe";
import Footer from "@/components/Footer";
import BookingModal from "@/components/BookingModal";
import AdminCalendar from "@/components/AdminCalendar";

function App() {
  if (typeof window !== "undefined" && window.location.pathname.startsWith("/admin/calendar")) {
    return (
      <div className="App">
        <AdminCalendar />
      </div>
    );
  }
  return (
    <BookingProvider>
      <div className="App">
        <Navbar />
        <main>
          <Hero />
          <About />
          <Pillars />
          <Coaching />
          <Pricing />
          <CleanEnergy />
          <Books />
          <MeVsMe />
        </main>
        <Footer />
        <BookingModal />
        <Toaster
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#0C142A",
              border: "1px solid #1D2847",
              color: "#F8F9FA",
            },
          }}
        />
      </div>
    </BookingProvider>
  );
}

export default App;
